<template>

  <router-view/>

  <div class="h-16"></div>
  <!--  Bottom Navigation -->
  <nav
      class="fixed flex justify-between w-4/5 bg-white rounded-full left-0 right-0 mx-auto bottom-7 shadow-md overflow-hidden">
    <BottomNavigationItem to="/" name="خانه">
      <HomeIcon class="w-6 h-6 ml-1"/>
    </BottomNavigationItem>
    <BottomNavigationItem to="/history" name="سوابق">
      <CollectionIcon class="w-5 h-5 ml-1"/>
    </BottomNavigationItem>
    <BottomNavigationItem to="/about" name="بیشتر">
      <DotsHorizontalIcon class="w-5 h-5 ml-1"/>
    </BottomNavigationItem>
  </nav>

</template>

<script>
import {CollectionIcon, DotsHorizontalIcon, HomeIcon} from "@heroicons/vue/outline";
import BottomNavigationItem from "./components/BottomNavigationItem";

export default {
  name: 'App',
  components: {BottomNavigationItem, HomeIcon, CollectionIcon, DotsHorizontalIcon},
}
</script>

<style>
@font-face {
  font-family: 'iransans';
  src: url('assets/font/iran_sans.ttf');
}

* {
  -webkit-tap-highlight-color: transparent;
}

html, body {
  font-family: 'iransans' !important;
  direction: rtl;
  @apply bg-gray-100
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
